export const GET_TOTAL_BOOKED_SLOTS_START = 'GET_TOTAL_BOOKED_SLOTS_START';

export const GET_TOTAL_BOOKED_SLOTS_SUCCESS = 'GET_TOTAL_BOOKED_SLOTS_SUCCESS';

export const GET_TOTAL_BOOKED_SLOTS_FAILURE = 'GET_TOTAL_BOOKED_SLOTS_FAILURE';
